import assign from 'object-assign';
import _ from 'lodash';
import { arrayAny } from '../../utils/arrayUtils';

export class MenuAPI {

  // Current roles checked @ 06/07/2023
  // 'Tenant.Manager', 'User.Basic', 'Billing.Admin', 'Application.Developer'

  static menuItems = [
    { path: '/dashboard', icon: 'fa fa-home', title: 'Home', rolesRequired: ['User.Basic'] },
    { path: '/calendar', icon: 'fa fa-calendar', title: 'Calendar', rolesRequired: ['User.Basic'] },
    { path: '/kanban', icon: 'fa fa-bars-staggered', title: 'Kanban Board', rolesRequired: ['User.Basic'] },
    {
      path: '#', icon: 'fa fa-cog', title: 'Manage Properties', rolesRequired: ['User.Basic'],
      children: [
        { path: '/property/search', icon: 'fa fa-magnifying-glass', title: 'Search', rolesRequired: ['User.Basic'] },
        { path: '/property/map', icon: 'fa fa-map', title: 'Properties Map', rolesRequired: ['User.Basic'] }
      ]
    },
    { path: '/company/search', icon: 'fa fa-users', title: 'Manage Companies', rolesRequired: ['Tenant.Manager'] },
    { path: '/landlords/search', icon: 'fa fa-users', title: 'Manage Landlords', rolesRequired: ['User.Basic'] },

    { path: '#', icon: 'fa fa-users', title: 'Manage Tenants', rolesRequired: ['User.Basic'],
      children: [
        { path: '/tenant/search', icon: 'fa fa-magnifying-glass', title: 'Search', rolesRequired: ['User.Basic'] },
        { path: '/tenant/rent-tracker', icon: 'fa fa-gbp', title: 'Rent Tracker', rolesRequired: ['User.Basic'] }
      ]
     },

    { path: '/user-debug', title: 'User Debug', rolesRequired: ['Application.Developer'] },
    { path: '/user-graph', title: 'User Graph', rolesRequired: ['Application.Developer'] },

    { path: '/docs/file-manager', icon: 'fas fa-file-lines', title: 'File Manager', rolesRequired: ['User.Basic'] },
    { path: '/users/manage', icon: 'fa fa-users', title: 'Manage Users', rolesRequired: ['Application.Developer'] },

  ];

  filterMenusByUserClaims = (data, roles) => {

    const items = [];

    for (const item of data) {
      const intersection = _.intersection(item.rolesRequired, roles || []);
      if (arrayAny(intersection)) {

        item.children = arrayAny(item.children) ? this.filterMenusByUserClaims(item.children, roles) : [];
        items.push(item);
      }
    }

    return items;
  }

  getMenuItems = source => {

    return new Promise(async (resolve, reject) => { // eslint-disable-line no-unused-vars
      let roles = [];

      // Support being passed either a roles array, an MSAL account, or a token response
      if (Array.isArray(source)) {
        roles = source;
      } else if (source?.idTokenClaims?.roles) {
        roles = source.idTokenClaims.roles;
      } else if (source?.roles) {
        roles = source.roles;
      }

      const items = this.filterMenusByUserClaims(MenuAPI.menuItems, roles);
      
      // Set loading state for the badge
      const propertyMenuItem = items.find(item => item.title === 'Manage Properties');
      if (propertyMenuItem) {
        propertyMenuItem.badgeLoading = true;
      }
      
      // Return items immediately with loading state
      resolve(assign([], items));
      
      // Simulate API delay (will be replaced with real kanban API call)
      setTimeout(() => {
        if (propertyMenuItem) {
          propertyMenuItem.badge = '10';
          propertyMenuItem.badgeLoading = false;
          window.dispatchEvent(new CustomEvent('menuUpdate', { detail: items }));
        }
      }, 5000);
    });
  };
}